import { Injectable, signal } from '@angular/core';
import { Skin } from '@core/interfaces/skin.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminCaseEditService {
  public readonly caseSkins = signal<Skin[]>([]);

  public deleteSkin(skin: Skin) {
    this.caseSkins.update((prev) =>
      prev.filter((s) => s.assetid !== skin.assetid)
    );
  }
}
